import { render, staticRenderFns } from "./TenantIpRestrictionDialog.vue?vue&type=template&id=143e206c"
import script from "./TenantIpRestrictionDialog.vue?vue&type=script&lang=ts"
export * from "./TenantIpRestrictionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports